import { Card, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CardContent from '@mui/material/CardContent'
import { Colors } from 'constants/colors'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import ButtonBase from '@mui/material/ButtonBase'
import GoogleIcon from '@mui/icons-material/Google'
import RedditIcon from '@mui/icons-material/Reddit'

import { TikTokIcon } from './TikTokIcon'

const CardStyle = styled(Card)({
  margin: '20px',
  width: '225px',
  height: '225px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'rgba(155, 155, 144, 0.2) 0px 7px 29px 0px',
  borderRadius: '15px',
  transition: 'transform .2s',
  backgroundColor: Colors.backgroundDark,
  ':hover': {
    transform: 'scale(1.1)',
  },
})

const ButtonStyle = styled(ButtonBase)({
  width: '100%',
})

const CardContentStyle = styled(CardContent)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const CardTitle = styled(Typography)({
  fontSize: '22px',
  color: Colors.darkDeepGray,
  fontWeight: 700,
  margin: 0,
  padding: 0,
})
const CardSubtitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: 0.7,
  margin: 0,
  padding: 0,
})

const FacebookIconStyle = styled(FacebookIcon)({
  color: Colors.darkBlue,
  fontSize: '48px',
})

const InstagramIconStyle = styled(InstagramIcon)({
  color: Colors.pink,
  fontSize: '48px',
})

const TwitterIconStyle = styled(TwitterIcon)({
  color: Colors.lightBlue,
  fontSize: '48px',
})

const LinkedInIconStyle = styled(LinkedInIcon)({
  color: Colors.deepBlue,
  fontSize: '48px',
})
const GoogleIconStyle = styled(GoogleIcon)({
  color: Colors.red,
  fontSize: '48px',
})

const RedditIconStyle = styled(RedditIcon)({
  color: Colors.orangeRed,
  fontSize: '48px',
})

const TikTokIconStyle = styled(TikTokIcon)({
  color: Colors.white,
  fontSize: '48px',
})

const SocialMediaCardStyle = {
  CardStyle,
  CardContentStyle,
  ButtonStyle,
  CardTitle,
  CardSubtitle,
  FacebookIconStyle,
  LinkedInIconStyle,
  TwitterIconStyle,
  InstagramIconStyle,
  GoogleIconStyle,
  RedditIconStyle,
  TikTokIconStyle,
}

export default SocialMediaCardStyle
